import {useMemo} from 'react'
import {downloadCSVFiles, getDateWithTimeString} from '@/helpers/shadcn/utils'
import {useDataTable} from '@/hooks/useDataTable-hook'
import {GetFormattedActivityData} from '@/models/ActivityListModel'
import {getActivityCsvFile, handleGetActivity} from '@/services/activities'
import {ActivitiesColConfig} from '@/services/MockData/Activity/ActivitiesColConfig'
import {useQuery} from '@tanstack/react-query'

const initialSortConfig = {
  column: ActivitiesColConfig[6].name_of_db_column,
  direction: 'desc',
}

export const useActivites = () => {
  const {setPageIndex, setSortingObj, setSearchArry, pageIndex, sortingObj, searchArr, handleResetAll} = useDataTable(0, false, false, initialSortConfig)
  const queryParams = useMemo(() => {
    const params = new URLSearchParams()

    if (sortingObj?.column) {
      params.append('sortBy', sortingObj.column)
      params.append('order', sortingObj.direction)
    }

    // Add pagination parameters
    params.append('pageSize', 10)
    params.append('page', pageIndex || 0)

    // Add search parameters if available
    // if (searchArr?.length > 0) {
    //   searchArr.forEach(searchObj => {
    //     params.append(searchObj.field, searchObj.value)
    //   })
    // }

    return params.toString()
  }, [sortingObj?.column, sortingObj?.direction, pageIndex])

  const {data,isPending,isError} = useQuery({
        queryKey: ['GET_ACTIVITY', queryParams, searchArr],
        queryFn: () => handleGetActivity(queryParams, searchArr),
      })

  const onDownloadBtnClick = async selectedIds => {
    const body = {
      ids: selectedIds,
      filters: searchArr,
    }

    const data = await getActivityCsvFile(queryParams,body)
    const fileName = `Activity_${getDateWithTimeString()}`
    downloadCSVFiles(data, fileName)
  }

  // Sync sorting state from API response
  const resultsData = useMemo(() => data || {}, [data])

  const activityListData = useMemo(() => GetFormattedActivityData(resultsData), [resultsData])

  return {
    activityListData,
    activityLColConfigData: ActivitiesColConfig,
    pageIndex,
    setPageIndex,
    setSortingObj,
    sortingObj,
    setSearchArry,
    onDownloadBtnClick,
    handleResetAll,
    isPending,
    isError
  }
}
